import React, { Fragment } from 'react';
import Button from '@material-ui/core/Button';
import Skeleton from '@material-ui/lab/Skeleton';
import { Card, CardContent } from '@material-ui/core';
import AutoCompleteComponent from '../../sharedComponents/AutoCompleteComponent';
import SelectComponent from '../Select';

function checkColor(field) {
  if (Array.isArray(field.individual) && field.individual.length > 0) {
    return '#FFA500';
  }
  if (Array.isArray(field.excluir) && field.excluir.length > 0) {
    return '#FFA500';
  }
  if (
    Array.isArray(field.excluir_intervalos) &&
    field.excluir_intervalos.length > 0
  ) {
    return '#FFA500';
  }
  if (Array.isArray(field.intervalo) && field.intervalo.length > 0) {
    return '#FFA500';
  }
}

const FieldsArray = props => {
  const { fields, loading, onChangeField, classes, onSelectField } = props;

  return (
    <>
      <Card>
        <CardContent>
          <div id='header' className={classes.fieldListHeader}>
            <h4>Campo</h4>
            <h4>Condición</h4>
            <h4>Desde</h4>
            <h4>Hasta</h4>
            <h4>Puntual</h4>
          </div>
          {!loading ? (
            fields?.campos?.map((field, index) => (
              <div className={classes.fieldList} key={field.campo_id}>
                <p style={{ width: '20rem' }}>
                  {field.campo_display?.toUpperCase()}
                </p>
                <SelectComponent
                  variant='outlined'
                  value={field.condicion || ''}
                  onChange={event =>
                    onChangeField(
                      event.target.value,
                      'condicion',
                      field,
                      index
                    )
                  }
                />
                <AutoCompleteComponent
                  variant='outlined'
                  value={field.desde || ''}
                  options={field?.autocompletar}
                  onChange={(event, newValue) =>
                    onChangeField(newValue, 'desde', field, index)
                  }
                />
                <AutoCompleteComponent
                  variant='outlined'
                  value={field.hasta || ''}
                  options={field?.autocompletar}
                  onChange={(event, newValue) =>
                    onChangeField(newValue, 'hasta', field, index)
                  }
                />
                <Button
                  onClick={() => onSelectField(field, index)}
                  variant='contained'
                  style={{ background: checkColor(field) || '#1B1B1B' }}
                  color='secondary'
                >
                    IN
                </Button>
              </div>
            ))
          ) : (
            <>
              {Array.from(new Array(15)).map(() => (
                <Fragment key={Math.random()}>
                  <Skeleton variant='text' height={50} />
                </Fragment>
              ))}
            </>
          )}
        </CardContent>
      </Card>
    </>
  );
};

export default FieldsArray;
